import { useEffect, useRef } from "react"

import { Button } from "@components/ui/button"
import { useAccountOfferFunnel } from "@components/AccountNew/OfferFunnel/utils/useAccountOfferFunnel"

export const Confirmation = () => {
  const topRef = useRef<HTMLDivElement>(null)
  const { setStep, eligibleOfferType, selectedOffer, confirmedOrder } =
    useAccountOfferFunnel()

  useEffect(() => {
    topRef.current?.scrollIntoView({ behavior: "smooth", block: "end" })
  }, [])

  return (
    <div ref={topRef} className="tw:flex tw:flex-col tw:gap-2">
      <h4 className="tw:text-xl tw:font-semibold">
        {eligibleOfferType} Order Confirmation
      </h4>
      <p>Accepted Offer: {selectedOffer?.plan_name}</p>
      <p>Confirmation Code: {confirmedOrder?.new_order.confirmation_code}</p>
      <p>If you have any questions, please call Inspire at (866) 403-2620.</p>
      <Button className="tw:self-start" onClick={() => setStep("initial")}>
        Done
      </Button>
    </div>
  )
}
